import { Button, Heading, IconButton } from '@assembly-js/design-system';

import { ToolbarDivider } from 'src/components/ToolbarDivider';

interface AppSettingsModalHeaderProps {
  onClose: () => void;
  onSave: () => void;
  appName: string;
  dirty: boolean;
  isSaving: boolean;
}

export const AppSettingsModalHeader: React.FC<AppSettingsModalHeaderProps> = ({
  onClose,
  onSave,
  appName,
  dirty,
  isSaving,
}) => {
  return (
    <div className="flex shrink-0 items-center justify-between border-b border-solid border-x-0 border-t-0 border-non-hover-border bg-white px-4 sm:px-6 py-4 h-15">
      <div className="flex shrink-0 items-center gap-2 sm:gap-3 overflow-hidden pr-4">
        <IconButton
          icon="Close"
          onClick={onClose}
          label="Close"
          variant="minimal"
          className="text-black-heading"
          size="sm"
        />
        <ToolbarDivider />
        <Heading className="text-sm sm:text-lg text-black-heading truncate">
          {appName}
        </Heading>
      </div>

      <div className="flex items-center gap-2.5">
        <Button
          label="Save Changes"
          variant="primary"
          onClick={onSave}
          loading={isSaving}
          disabled={!dirty || isSaving}
          size="sm"
          type="submit"
        />
      </div>
    </div>
  );
};
